const projects = [
  {
    title: "Education Management System",
    type: 'product',
    category: 'EDUCATION',
    platform: 'Web Solution',
    FechorService: 'Admin, Teacher, Student, and Parent Portal, Craete & Publish Class, One Click Class Schedule, etc.',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "It covers all educational setups providing an effective and efficient way of managing classes. Provides the ability to manage programs, sessions, classes, admissions, enrolments, teachers, students, conduct classes, etc.",
    link: "/caseStudies/products/classManagement",
  },
  {
    title: "Distribution with D365",
    type: 'product',
    category: 'DISTRIBUTION',
    platform: 'Windows Application',
    FechorService: 'Order, Quantity, Price Integration between D365 and Xtack',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'MicrosoftDynamics'],
    description:
      "The distribution utility is integrated with Microsoft Dynamics D365. The purpose of this utility is to provide users ability to create transfer order in bulk from outside the Microsoft Dynamics D365.",
    link: "/caseStudies/products/mD365BulkStockDistribution",
  },
  {
    title: "VIZTOS POS",
    type: 'product',
    category: 'RETAIL',
    platform: 'Web Solution, Odoo Integration',
    FechorService: 'Offline Ordering, Fully personlizable product cards, Specially made for Cafe and lubricant Station, KDS, Multi-user Session, etc.',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "A POS system that provides the capability to perform retail sales from multiple platforms (Windows, Mac OS, Android tab). It comes with complete ERP at the back where customers can efficiently manage their purchases, inventory, accounts, payroll, etc.",
    link: "/caseStudies/products/viztos",
  },
  {
    title: "Visioedge A Complete Solution",
    type: 'Product',
    category: 'ERP Solution',
    platform: 'Odoo based Solution',
    FechorService: 'Strong Suply Chain, Specialized Feature for Restaurants, Robust internal or External Communication Workflows, etc.',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "One product covers most of the buniess opperation needs for small to med level orginizations. ",
    link: "/caseStudies/products/visioedge",
  },
  {
    title: "Umrah Shuttle App",
    type: 'product',
    category: 'Travel',
    platform: 'Mobile Application',
    FechorService: 'Umrah shuttle booking, Tracking custoner and driver location',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "This application bridge the travel agents and Umrah visitors, Umrah shuttle booking, Tracking custoner and driver's location, etc.",
    link: "",
  },
  {
    title: "Big Jerry's Fencing App",
    type: 'Project',
    category: 'Field Service',
    platform: 'Mobile Application',
    FechorService: 'Assigned jobs, process a job, upload evidance and checklists',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "Fencing installation staff Application, Installer can check assigned jobs, process a job, upload evidance and checklists regarding the job complition.",
    link: "",
  },
  {
    title: "SNGPL Mobile Application",
    type: 'project',
    category: 'CUSTOMER SERVICE',
    platform: 'Mobile Application',
    FechorService: 'GAS Connection Application, Download Bill, Pay GAS bill, Bill History',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "We developed a mobile application for SNGPL to get new connection requests from users.",
    link: "",
  },
  {
    title: "State Bank of Pakistan Mobile Application",
    type: 'project',
    category: 'CUSTOMER SERVICE',
    platform: 'Mobile Application',
    FechorService: 'Customer Complaint Creation, Complaint processing updates',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "We developed a mobile application for State Bank of Pakistan to get complaints regarding banks in pakistan from users.",
    link: "",
  },
  {
    title: "Firhaj Footwear (Pvt.) Ltd ERP Support",
    type: 'project',
    category: 'ERP',
    platform: 'Team Extention',
    FechorService: 'Microsoft Dynamics 365 Support',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "We support Firhaj Footwear to customize and maintain its Dynamics AX 2012 ERP and its integration with other systems.",
    link: "",
  },
  {
    title: "Averti Infotech Delivery schedule and dropoff Mobile App",
    type: 'project',
    category: 'LOGISTICS',
    platform: 'Mobile Application',
    FechorService: 'Mobile Application Developement, Integration with Odoo',
    technologies: ['react', 'javascript'],
    description:
      "This is a Delivery App which helps vehicle drivers to manage there delivery. Features: Vehicle drivers can check in starting inventory, Vehicle drivers can the assigned deliveries, Vehicle drivers can close the daily orders.",
    link: "",
  },
  {
    title: "Aamaal Group of Companies Odoo Implementation and support",
    type: 'project',
    category: 'ERP',
    platform: 'Team Extention',
    FechorService: 'Odoo Implementation and Support',
    technologies: ['react', 'javascript'],
    description: "Odoo implementation for there day to day processes.",
    link: "",
  },
  {
    title: "Muscat Media Group Odoo HR Solution",
    type: 'project',
    category: 'ERP',
    platform: 'ERP Solution',
    FechorService: 'Odoo Implementation and Support',
    technologies: ['react', 'javascript'],
    description:
      "Odoo implementation for there day to day processes. Modules: HR, Payroll, Inventory, Sales etc.",
    link: "/caseStudies/projects/muscatMediaGroup",
  },
  {
    title: "United Alzahra Co LLC Odoo upgradation from 10 to 13",
    type: 'project',
    category: 'ERP',
    platform: 'ERP Solution',
    FechorService: 'Odoo Upgrade and Support',
    technologies: ['react', 'javascript'],
    description:
      "We helpped them Odoo upgrade from version 10 to 13 with all there customizations included.",
    link: "",
  },
  {
    title: "ZiePie Azure Services Support",
    type: 'project',
    category: 'CLOUD',
    platform: 'Team Extention',
    FechorService: 'Azure Cloud Management Services',
    technologies: ['react', 'javascript'],
    description:
      "We helpped them create data factories to migrate the data from one database to another.",
    link: "/portfolio/projects/ziePieAzureServiceSupport",
  },
  {
    title: "ZiePie PowerBI development",
    type: 'project',
    category: 'Power BI',
    platform: 'Team Extention',
    FechorService: 'Power BI Dashboards Development',
    technologies: ['react', 'javascript'],
    description:
      "We helpped them create many dashboard to visualize there data in the meaningful form.",
    link: "",
  },
  {
    title: "Farm/Poultry Management System",
    type: 'product',
    category: 'FARMING',
    platform: 'Web Solution',
    FechorService: 'Farm Management, Supply Chain Management',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "It is the perfect software for any cattle/poultry farm to run its operations. It provides features that can help manage your livestock, feed, medicine, and daily operations.",
    link: "",
  },
  {
    title: "Tender Asset Record Management",
    type: 'product',
    category: 'ASSET',
    platform: 'Web Solution',
    FechorService: 'Complete Tender processing documentation starage',
    technologies: ['html', 'css', 'sass', 'bootstrap', 'js', 'reactjs'],
    description:
      "It supports the tender processing by maintaining records for every step performed from budget approval to tender issuance to asset management.",
    link: "",
  },
]

const technologies = [
  "Frontend Web Development",
  "Backend Development",
  "Mobile App Development",
  "Databases",
  "Infra & DevOps",
  "ERP Solutions",
]
const events = [
  {
    id: 0,
    heading: "COMING SOON! a robust bootcampe for anyone who want's to be a successfull Mobile Developer",
    dataTime: '12th jan, 2024',
    description:
      "Header event details",
    location: 'Onile Session',
    button: 'Register'
  },
  {
    id: 1,
    heading: "We employ a well-established agile methodology to ensure the swift",
    description:
      "We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift",
    dataTime: '12th jan, 2024',
    location: 'Onile Session',
    button: 'Register'
  },
  {
    id: 2,
    heading: "We employ a well-established agile methodology to ensure the swift",
    description:
      "We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift",
    dataTime: '12th jan, 2024',
    location: 'Onile Session',
    button: 'Register'
  },
  {
    id: 3,
    heading: "We employ a well-established agile methodology to ensure the swift",
    description:
      "We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift",
    dataTime: '12th jan, 2024',
    location: 'Onile Session',
    button: 'Register'
  },
  {
    id: 4,
    heading: "We employ a well-established agile methodology to ensure the swift",
    description:
      "We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift",
    dataTime: '12th jan, 2024',
    location: 'Onile Session',
    button: 'Watch Recording'
  },
  {
    id: 5,
    heading: "We employ a well-established agile methodology to ensure the swift",
    description:
      "We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift",
    dataTime: '12th jan, 2024',
    location: 'Onile Session',
    button: 'Watch Recording'
  },
  {
    id: 6,
    heading: "We employ a well-established agile methodology to ensure the swift",
    description:
      "We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift We employ a well-established agile methodology to ensure the swift",
    dataTime: '12th jan, 2024',
    location: 'Onile Session',
    button: 'Watch Recording'
  },
]
const emails = {
  info: "info@visiomate.com",
  hr: "hr@visiomate.com",
}

export { projects, technologies, emails, events }
